import React from "react";
import { ArrowRightIcon, PhoneIcon } from "lucide-react";
import { business } from "../data/site";
type CtaPairProps = {
  tone?: "light" | "dark";
  quoteLabel?: string;
};
export function CtaPair({
  tone = "light",
  quoteLabel = "RINNAI QUOTE"
}: CtaPairProps) {
  const isDark = tone === "dark";
  return <div className="grid gap-3 sm:grid-cols-2" data-id="element-26" data-mp="3eucj46mcwbef">
      <a href="#quote" className={`flex min-h-16 w-full items-center justify-between gap-4 rounded-md px-6 py-3 text-sm font-bold transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${isDark ? "bg-white text-rinnai hover:bg-soft focus-visible:ring-white focus-visible:ring-offset-rinnai" : "bg-rinnai text-white hover:bg-rinnaiDark focus-visible:ring-rinnai"}`} data-id="element-27" data-mp="3etkn4uoukbnm">
        <span className="flex flex-col items-start leading-5" data-id="element-28" data-mp="28805ki57ncls">
          <span data-id="element-29" data-mp="23842qm891r7t">GET MY FREE</span>
          <span data-id="element-30" data-mp="238vybx1ujoy3">{quoteLabel}</span>
        </span>
        <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-31" data-mp="23a7422eur6ru" />
      </a>
      <a href={business.phoneHref} className={`flex min-h-16 w-full items-center justify-start gap-4 rounded-md border px-6 py-3 text-sm font-bold transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${isDark ? "border-white text-white hover:bg-white hover:text-rinnai focus-visible:ring-white focus-visible:ring-offset-rinnai" : "border-ink text-ink hover:bg-ink hover:text-white focus-visible:ring-rinnai"}`} data-id="element-32" data-mp="1n2kx78gnowks">
        <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-33" data-mp="2aoht9b1ve5ob" />
        <span className="flex flex-col items-start leading-5" data-id="element-34" data-mp="2fqgry7mo0eex">
          <span data-id="element-35" data-mp="2jqqxxkagj4ts">CALL</span>
          <span data-id="element-36" data-mp="2jpzef7u4wxjv">{business.phoneDisplay}</span>
        </span>
      </a>
    </div>;
}